export enum OccupancyEnum {
  High = "high",
  Medium = "medium",
  Low = "low",
}
